<!--
* UIID: UI-DLB-MBL-170
* UI Name: Mapper Check In
* Modify Date: 2021/02/18
-->
<template>
  <dialog-drag
    :id="id"
    :ref="'dialog-' + id"
    @close="removeDialog"
    @drag-end="dialogDragEnd"
    @drag-start="selectDialog"
    @move="dialogDragEnd"
    class="dialog-drag-display add-map-layout-dialog custom-add-map-layout-dialog"
  >
    <!-- [S]  Popup title-->
    <template v-slot:title>
      <v-card-title class="headline white--text" primary-title>
        {{ $t('lbl.mapBuilder.builderCheckIn.mapperCheckInHeader') }}
      </v-card-title>
    </template>
    <template v-slot:button-close>
      <v-icon class="ma-2" small @click="removeDialog" color="white">fas fa-times</v-icon>
    </template>
    <!-- [E]  Popup title-->

    <!-- [S]  Popup body-->
    <v-card class="dialog-container">
      <!-- [S]  Popup body-->

      <v-form ref="form" class="dialog-content">
        <v-row class="ml-0 mr-0">
          <v-col class="not-required-col field-col pt-0" lg="2">
            <span class="field-label required-text">
              {{ $t('lbl.mapBuilder.builderCheckIn.mapName') }}
            </span>
          </v-col>
          <v-col class="map-text-field inline-block-component pt-0 pl-0" lg="10">
            <v-text-field
              v-if="versionList"
              v-model="mapName"
              class="data-table-filter-text-field inline-block-component text-field-flatfile-layout flatfile-textfield scanner-textfield"
              heigth="30"
              outlined
              hide-details
              dense
              solo
              readonly
            >
            </v-text-field>
            <v-autocomplete
              v-else
              v-model="contenInput"
              :items="mapNameList"
              @change="changeSelect"
              placeholder=""
              :class="[
                'data-table-filter-text-field text-field-flatfile-layout flatfile-textfield scanner-textfield',
              ]"
              outlined
              hide-details
              height="30"
              dense
              solo
            ></v-autocomplete>
          </v-col>
        </v-row>
        <v-row>
          <v-col lg="12" class="customer-add-map-layout">
            <div class="layout-chkin-color_u">
              <a @click="openCodeTableDialog">{{ selectCodeName }}</a>
            </div>
          </v-col>
        </v-row>
        <v-row class="ml-0 mr-0">
          <v-col class="required-col field-col" lg="2">
            <v-icon x-small>fas fa-asterisk</v-icon>
            <span class="field-label required-text">
              {{ $t('lbl.mapBuilder.builderCheckIn.mapperName') }}
            </span>
          </v-col>
          <v-col class="map-text-field inline-block-component pl-0" :lg="isDlb ? 7 : 10">
            <v-text-field
              v-model="mapperNameContent"
              :class="[
                'data-table-filter-text-field text-field-flatfile-layout flatfile-textfield scanner-textfield',
              ]"
              height="30"
              outlined
              hide-details
              dense
              solo
              readonly
            >
            </v-text-field>
          </v-col>
          <v-col v-if="isDlb" lg="3" :class="['map-text-field pr-0 ', isDlb ? 'pl-3' : ' pl-0']">
            <v-select
              v-model="libraryVersion"
              @change="onVersionChange(libraryVersion)"
              :items="libraryItem"
              class="data-table-select-box srm-select-box custom-selectbox flatfile-layout-selectbox communication-select-box"
              ref="refMapTypeTo"
              height="30"
              dense
              solo
              outlined
            >
            </v-select>
          </v-col>
        </v-row>
        <v-row class="ml-0 mr-0">
          <v-col class="required-col field-col pb-0" lg="2">
            <v-icon x-small>fas fa-asterisk</v-icon>
            <span class="field-label required-text">
              {{ $t('lbl.mapBuilder.builderCheckIn.comment') }}
            </span>
          </v-col>
          <v-col class="map-text-field inline-block-component pb-0 pl-0" lg="10">
            <v-text-field
              v-model="contentComment"
              :class="[
                'data-table-filter-text-field text-field-flatfile-layout flatfile-textfield scanner-textfield',
              ]"
              heigth="30"
              ref="comRef"
              outlined
              hide-details
              dense
              solo
            >
            </v-text-field>
          </v-col>
        </v-row>
      </v-form>
      <v-row class="ml-0 mr-0">
        <v-col class="button-col action-col" lg="12">
          <div class="btn-form-control text-right">
            <v-btn class="btn btn-search" color="primary" @click="saveCheckIn()">
              <v-icon x-small class="mr-2">fas fa-save</v-icon>{{ $t('btn.common.save') }}
            </v-btn>
            <v-btn class="btn btn-delete" @click="removeDialog">
              <v-icon small color="white" class="mr-1">fa fa-times</v-icon
              >{{ $t('btn.common.cancel') }}
            </v-btn>
          </div>
        </v-col>
      </v-row>
      <!-- [E]  Popup button-->
      <!-- [E]  Popup body-->
    </v-card>
    <dialogWindow
      ref="detailDialog"
      size="max"
      :detail="detailDialog"
      color="warning"
      @select-ok="clickAlert"
    >
    </dialogWindow>
    <dialogWindow
      ref="successDialog"
      size="max"
      color="success"
      :detail="$t('msg.common.saveSuccess', ['Mapper'])"
      @select-ok="saveSuccess"
    >
    </dialogWindow>
  </dialog-drag>
</template>

<script>
/* globals Store */

import DialogDrag from '@/vue-dlb/components/vue-dialog-drag.vue';
import { mapState } from 'vuex';
/* 2020/11/11 203737 Remove unused source
import {UploadFile} from '@/vue-dlb/models'*/
import dialogWindow from '@/vue-dlb/components/NewDialog.vue';
import cfg from '@/vue-caas/config/config.js';

import {
  showProgress,
  hideProgress,
  /* 2020/11/11 203737 Remove unused source
  showSuccessMessage,
  showErrorMessage,
  alertSuccess,
  closeAlert*/
} from '@/vue-dlb/utils/sys-util.js';
import EventBus from '@/vue-caas/views/process/component/event-bus.js';

export default {
  components: {
    DialogDrag,
    dialogWindow,
  },
  name: 'mapper-checkin-dialog',
  // props: ['id', 'title', 'options', 'eventCb', 'closeDialog', 'dragStart', 'dragEnd', 'scannerType']
  props: {
    id: String,
    title: String,
    options: Object,
    eventCb: Function,
    closeDialog: Function,
    dragStart: Function,
    dragEnd: Function,
    scannerType: String,
    versionList: Object,
  },
  computed: {
    /* 2020/11/11 203737 Remove unused source
    ...mapState("common", {
      uploadedFile: "uploadedFile"
    }),*/
    ...mapState('common', {
      repomenuMode: 'repomenuMode',
    }),
    ...mapState('mapbuilder', {
      chkinMapList: 'chkinMapList',
      libList: 'libList',
    }),
    ...mapState('codetable', {
      codetables: 'codetables',
    }),
  },
  data() {
    return {
      selectCodeName: this.$t('lbl.mapBuilder.builderCheckIn.codeCovertingTable'),
      selectCodeId: '',
      successDialog: false,
      detailDialog: '',
      mapName: '',
      mapperNameContent: '',
      /* 2020/11/11 203737 Remove unused source
    scannerName:'',*/
      contenInput: '',
      contentComment: '',
      uploadCheckIn: {
        header: [
          'MAP_PRCS_NO',
          'MAP_TYPE',
          'MAP_NAME',
          'MAP_COMT',
          'MAP_FILE_NAME',
          'MAP_FILE_ID',
          'MAP_FILE_SIZE',
          'CODE_CTG_ID',
          'LIB_VER',
          'ORA_VER',
          'TARGET_FILE_NAME',
          'TARGET_FILE_ID',
        ],
        data: [
          {
            MAP_PRCS_NO: '',
            MAP_TYPE: '',
            MAP_NAME: '',
            MAP_COMT: '',
            MAP_FILE_NAME: '',
            MAP_FILE_ID: '',
            MAP_FILE_SIZE: '',
            CODE_CTG_ID: '',
            LIB_VER: '',
            ORA_VER: '',
            TARGET_FILE_NAME: '',
            TARGET_FILE_ID: '',
            file: null,
          },
        ],
      },
      mapItems: {
        header: [
          'REPO_MODE',
          'OWNR_FLAG',
          'ADMIN_YN',
          'CUST_ID',
          'OWNR_CUST_ID',
          'MAP_CONV_TP',
          'BUILD_TP',
        ],
        data: [
          {
            REPO_MODE: '',
            OWNR_FLAG: '',
            ADMIN_YN: '',
            CUST_ID: '',
            OWNR_CUST_ID: '',
            MAP_CONV_TP: '',
            BUILD_TP: 'M',
          },
        ],
      },
      mapNameList: [],
      librarySearchItem: {
        header: ['CUST_ID'],
        data: [
          {
            CUST_ID: '',
          },
        ],
      },
      codetableItems: {
        header: ['CUST_ID', 'OWNR_CUST_ID'],
        data: [
          {
            CUST_ID: '',
            OWNR_CUST_ID: '',
          },
        ],
      },
      libraryItem: [{ text: 'Compile library', value: '' }],
      libraryVersion: '',
      oracleVersion: '',
      isDlb: false,
      isEdit: false,
    };
  },
  created() {
    this.isDlb = cfg.isDlb;
    this.getLibraryVersion();
    this.queryMap();
    if (this.versionList) {
      this.isEdit = true;
      this.mapName = this.versionList.MAP_NAME;
      this.contenInput = this.versionList.MAP_PRCS_NO;
      this.mapperNameContent = this.versionList.MAPPER_NAME;
      if (this.versionList.CODE_CTG_ID != null && this.versionList.CODE_CTG_ID != '') {
        this.selectCodeName = this.versionList.CODE_CTG_NAME;
        this.selectCodeId = this.versionList.CODE_CTG_ID;
      }
    }
  },
  mounted() {
    setTimeout(() => {
      this.$refs.comRef.focus();
    }, 300);
  },
  methods: {
    getCodetables(data) {
      this.codetableItems.data[0].CUST_ID = this.$cookies.get('comp-id');
      this.codetableItems.data[0].OWNR_CUST_ID = this.$cookies.get('ownr-id');
      Store.dispatch('codetable/codetables', this.codetableItems).then(() => {
        this.codetables.forEach((item) => {
          if (data === item.CODE_CTG_ID) {
            this.updateSelectCodeTitle(item);
          }
        });
      });
    },
    onVersionChange(libver) {
      for (let i = 0; i < this.libList.length; i++) {
        if (libver === this.libList[i].SITE_CODE) {
          this.oracleVersion = this.libList[i].ORA_VER;
          break;
        }
      }
    },
    getLibraryVersion() {
      this.librarySearchItem.data[0].CUST_ID = $cookies.get('comp-id');
      Store.dispatch('mapbuilder/queryLibraryList', this.librarySearchItem).then(() => {
        for (let i = 0; i < this.libList.length; i++) {
          if (this.isDlb) {
            let item = this.libList[i];
            this.libraryItem.push({
              text: item.SITE_NAME,
              value: item.SITE_CODE,
            });
          } else {
            if (this.libList[i].SITE_CODE === 'for_platform') {
              let item = this.libList[i];
              this.libraryItem.push({
                text: item.SITE_NAME,
                value: item.SITE_CODE,
              });

              this.libraryItem.shift();
              break;
            }
          }
        }
        this.libraryVersion = this.options.item.data[3];
      });
    },
    queryMap() {
      if (this.repomenuMode) {
        // Repository Menu
        if ($cookies.get('login-user-comp-id') == cfg.provider) this.ACCESS_REPO_YN = 'NY';
        // CLT Super Provider
        else this.ACCESS_REPO_YN = 'YN'; // Normal User Admin
        this.mapItems.data[0].REPO_MODE = 'Y';
      } else {
        // Normal User
        this.ACCESS_REPO_YN = 'NN';
        this.mapItems.data[0].REPO_MODE = 'N';
      }

      if ($cookies.get('login-user-comp-id') == $cookies.get('ownr-id')) {
        this.mapItems.data[0].OWNR_FLAG = 'Y';
      } else {
        this.mapItems.data[0].OWNR_FLAG = 'N';
      }

      this.mapItems.data[0].ADMIN_YN = this.ACCESS_REPO_YN;
      this.mapItems.data[0].CUST_ID = this.$cookies.get('comp-id');
      this.mapItems.data[0].OWNR_CUST_ID = $cookies.get('ownr-id');
      this.mapItems.data[0].MAP_CONV_TP = this.changeCodeMapType();
      Store.dispatch('mapbuilder/queryCheckinMapList', this.mapItems).then(() => {
        this.getMapName();
      });
    },
    changeCodeMapType() {
      if (this.scannerType == 'ediscanner') return 'E';
      else if (this.scannerType == 'ediscanner_x12') return 'A';
      else if (this.scannerType == 'jsonscanner') return 'J';
      else if (this.scannerType == 'xmlscanner') return 'X';
      else return 'F';
    },
    getMapName() {
      for (let i = 0; i < this.chkinMapList.length; i++) {
        let item = this.chkinMapList[i];
        this.mapNameList.push({
          text: item.MAP_NAME + ' [' + item.MST_CUST_NM + ' - ' + item.DATA_TYPE + ']',
          value: item.MAP_PRCS_NO,
        });
      }
    },
    changeSelect() {
      this.chkinMapList.filter((item) => {
        if (item.MAP_PRCS_NO === this.contenInput) {
          this.mapperNameContent = item.MAPPER_NAME;
          if (item.CODE_CTG_ID != null) {
            this.getCodetables(item.CODE_CTG_ID);
          }
          return true;
        }
        return false;
      });
    },
    saveCheckIn() {
      if (this.mapperNameContent == null) this.mapperNameContent = '';
      if (this.contentComment == null) this.contentComment = '';
      if (this.libraryVersion == null) this.libraryVersion = '';
      if (
        this.mapperNameContent.trim() == '' ||
        this.contentComment.trim() == '' ||
        this.libraryVersion == ''
      ) {
        if (
          this.mapperNameContent.trim() == '' &&
          this.contentComment.trim() == '' &&
          this.libraryVersion == ''
        ) {
          this.detailDialog = this.$t('msg.common.requires', [
            'Mapper Name, Comment, Compile Library',
          ]);
        } else if (this.mapperNameContent.trim() == '' && this.contentComment.trim() == '') {
          this.detailDialog = this.$t('msg.common.require', ['Mapper Name, Comment']);
        } else if (this.mapperNameContent.trim() == '' && this.libraryVersion.trim() == '') {
          this.detailDialog = this.$t('msg.common.require', ['Mapper Name, Compile Library']);
        } else if (this.contentComment.trim() == '' && this.libraryVersion.trim() == '') {
          this.detailDialog = this.$t('msg.common.require', ['Comment, Compile Library']);
        } else if (this.mapperNameContent.trim() == '') {
          this.detailDialog = this.$t('msg.common.require', ['Mapper Name']);
        } else if (this.contentComment.trim() == '') {
          this.detailDialog = this.$t('msg.common.require', ['Comment']);
        } else if (this.libraryVersion.trim() == '') {
          this.detailDialog = this.$t('msg.common.require', ['Compile Library']);
        }
        this.$refs.detailDialog.dialog = true;
        return;
      }
      let validResult = this.$refs.form.validate();
      if (validResult) {
        let data = JSON.parse(JSON.stringify(this.chkinMapList));
        let saveItem = null;
        if (this.isEdit) {
          saveItem = this.versionList;
        } else {
          saveItem = data.find((item) => item.MAP_PRCS_NO === this.contenInput);
        }
        this.uploadCheckIn.data[0].MAP_PRCS_NO = saveItem.MAP_PRCS_NO;
        this.uploadCheckIn.data[0].MAP_TYPE = 'MAPP';
        this.uploadCheckIn.data[0].MAP_NAME = saveItem.MAP_NAME;
        this.uploadCheckIn.data[0].MAPPER_NAME = saveItem.MAPPER_NAME;
        this.uploadCheckIn.data[0].MAP_COMT = this.contentComment;
        this.uploadCheckIn.data[0].MAP_FILE_NAME = saveItem.MAPPER_NAME;
        this.uploadCheckIn.data[0].MAP_FILE_ID = this.options.item.data[0]; // TBD - by April. Please set scanner file id saved on a scrren.
        this.uploadCheckIn.data[0].MAP_FILE_SIZE = this.options.item.data[2];
        // CLV-Change Load CODE_CTG_ID from Select Code Table
        this.uploadCheckIn.data[0].CODE_CTG_ID = this.selectCodeId; // TBD - by April. Please change here for CodeTable
        if (this.isDlb) {
          this.uploadCheckIn.data[0].LIB_VER = this.libraryVersion;
        } else {
          this.uploadCheckIn.data[0].LIB_VER = 'for_platform';
        }
        this.uploadCheckIn.data[0].ORA_VER = this.oracleVersion;
        this.uploadCheckIn.data[0].TARGET_FILE_NAME = '';
        this.uploadCheckIn.data[0].TARGET_FILE_ID = '';
        this.uploadCheckIn.data[0].file = this.options.item.data[1];
        // Save Scanner
        showProgress();
        Store.dispatch('mapbuilder/saveCheckinMap', this.uploadCheckIn).then(() => {
          console.log('--------- Finished to process ----------');
          EventBus.$emit('updateMapperStatus', 'N');
          hideProgress();
          this.$refs.successDialog.dialog = true;
        });
      }
      return validResult;
    },
    saveSuccess() {
      this.openMapperVersionSave();
      this.removeDialog({});
    },
    clickAlert() {
      let self = this;
      setTimeout(() => {
        self.$refs.comRef.focus();
      }, 600);
    },
    removeDialog(dialog) {
      dialog.id = this.id;
      this.closeDialog(dialog);
    },
    selectDialog(obj) {
      this.dragStart(obj);
    },
    dialogDragEnd(obj) {
      this.dragEnd(obj);
    },
    openCodeTableDialog() {
      this.$emit('openCodeTableDialog');
    },
    updateSelectCodeTitle(item) {
      this.selectCodeName = item.CODE_CTG_NAME;
      this.selectCodeId = item.CODE_CTG_ID;
    },
    openMapperVersionSave() {
      this.$emit('openMapperVersionSave');
    },
  },
};
</script>
<style>
.mapper-chkin-select-box .v-text-field.v-text-field--solo.v-input--dense > .v-input__control {
  padding-left: 35px;
}
.mappercheckin-list .v-input__slot .v-select__slot {
  min-height: 30px !important;
}
.theme--light
  .mapper-chkin-select-box
  .v-text-field.mappercheckin-list.v-text-field--solo:not(.v-text-field--solo-flat)
  > .v-input__control
  > .v-input__slot {
  border: 1px solid #cedeff;
  border-radius: 3px;
}
.mapper-chkin-select-box
  .v-text-field.mappercheckin-list.v-text-field--solo:not(.v-text-field--solo-flat)
  > .v-input__control
  > .v-input__slot {
  padding-left: 14px !important;
}
.theme--dark
  .mapper-chkin-select-box
  .mappercheckin-list
  .v-input__control
  .v-input__slot
  .v-select__selections
  .v-select__selection {
  color: #ffffff !important;
}
.theme--dark
  .mapper-chkin-select-box
  .v-text-field.mappercheckin-list.v-text-field--solo:not(.v-text-field--solo-flat)
  > .v-input__control
  > .v-input__slot {
  background: #3b3e49 !important;
}
.mapper-chkin-select-box .upload-file-row-1-v .v-input__slot {
  padding-right: 0px !important;
}
.mapper-chkin-select-box
  .mappercheckin-list
  .v-input__control
  .v-input__slot
  .v-select__slot
  input {
  padding: 8px 0px !important;
}
.theme--light .mapper-chkin-select-box .upload-file-row-1-v .v-text-field__slot {
  background: #eeeeee;
}
.theme--light .layout-chkin-color a {
  color: #0082ba !important;
}
.layout-chkin-color {
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  display: flex;
  align-items: center !important;
  text-decoration-line: underline !important;
  height: 30px;
}
.layout-chkin-color_u {
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 12px;
  text-align: right;
  /* justify: right; */
  text-decoration-line: underline !important;
  height: 15px;
}
.data-table-select-box.custom-selectbox.map-name-selectbox .v-input__control {
  border-radius: 3px;
  border: 1px solid #cedeff;
  background: #ffffff;
}
</style>
